import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class ProductSkuComponent extends Component {
  requiredRefs = ['skuContainer', 'sku'];
  #target;
  #revision = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('product-card, .shopify-section, dialog');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#revision++;
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#target = undefined;
    super.disconnectedCallback();
  }

  #handleProductSelect = (event) => {
    if (event.target.closest?.('product-card') && this.#target?.tagName !== 'PRODUCT-CARD') return;
    const revision = ++this.#revision;
    event.promise.then(({ detail }) => {
      if (!detail || revision !== this.#revision || !this.#target) return;
      const productId = String(detail.newProduct?.id ?? detail.productId ?? this.dataset.productId);
      if (!detail.newProduct && productId !== this.dataset.productId) return;
      const candidates = detail.html?.querySelectorAll('product-sku-component') ?? [];
      const source = Array.from(candidates).find((element) =>
        element.dataset.productId === productId &&
        (!this.dataset.blockId || !element.dataset.blockId || element.dataset.blockId === this.dataset.blockId)
      );
      if (!source && !detail.newProduct) return;
      const sku = source?.querySelector('[ref="sku"]')?.textContent?.trim() ?? '';
      this.dataset.productId = productId;
      this.refs.sku.textContent = sku;
      this.style.display = sku ? 'block' : 'none';
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[product-sku] Event promise rejected:', error);
    });
  };
}

if (!customElements.get('product-sku-component')) {
  customElements.define('product-sku-component', ProductSkuComponent);
}
